module.exports = __webpack_public_path__ + "img/IT0003819403031.f60b9c1a.png";